import { fetchWithTimeout, parseErrorResponse } from './base.ts';

export const historyApi = {
  /**
   * Get all soft-deleted records for a project (trash view).
   */
  getDeletedRecords: async (projectId: string): Promise<any[]> => {
    const res = await fetchWithTimeout(`/api/projects/${projectId}/deleted`);
    if (!res.ok) await parseErrorResponse(res);
    return res.json();
  },

  /**
   * Get version history for a specific record.
   */
  getRecordHistory: async (entityType: string, entityId: string): Promise<any[]> => {
    const res = await fetchWithTimeout(`/api/${entityType}/${entityId}/history`);
    if (!res.ok) await parseErrorResponse(res);
    return res.json();
  },

  /**
   * Get a specific version of a record.
   */
  getRecordVersion: async (entityType: string, entityId: string, version: number): Promise<any> => {
    const res = await fetchWithTimeout(`/api/${entityType}/${entityId}/history/${version}`);
    if (!res.ok) await parseErrorResponse(res);
    return res.json();
  },

  /**
   * Restore a soft-deleted record.
   */
  restoreRecord: async (entityType: string, entityId: string): Promise<any> => {
    const res = await fetchWithTimeout(`/api/${entityType}/${entityId}/restore`, {
      method: 'POST',
    });
    if (!res.ok) await parseErrorResponse(res);
    return res.json();
  },

  /**
   * Rollback a record to a specific version.
   */
  rollbackRecord: async (entityType: string, entityId: string, version: number): Promise<any> => {
    const res = await fetchWithTimeout(`/api/${entityType}/${entityId}/rollback`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ version }),
    });
    if (!res.ok) await parseErrorResponse(res);
    return res.json();
  },
};
